import styled, { keyframes, css } from 'styled-components';

const ANIMATION_DURATION_IN_MS = 1000;
const animation = keyframes `
    to {
        opacity: 0;
        transform: scale(2);
    }
`;
const animationRule = css `
    animation: ${animation} ${ANIMATION_DURATION_IN_MS}ms;
    animation-iteration-count: 1;
`;
const RippleSurface = styled.div `
    overflow: hidden;
    position: relative;
`;
const RippleEffect = styled.div `
    position: absolute;
    top: ${(props) => props.y}px;
    left: ${(props) => props.x}px;
    width: ${(props) => props.size}px;
    height: ${(props) => props.size}px;
    border-radius: 50%;

    opacity: 1;
    transform: scale(0);

    background-color: ${(props) => { var _a; return (_a = props.color) !== null && _a !== void 0 ? _a : props.theme.colors['Level 2']; }};

    ${animationRule};
`;

export { ANIMATION_DURATION_IN_MS, RippleEffect, RippleSurface };
